import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=d537f992&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=d537f992&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d537f992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d537f992')) {
      api.createRecord('d537f992', component.options)
    } else {
      api.reload('d537f992', component.options)
    }
    module.hot.accept("./AppMain.vue?vue&type=template&id=d537f992&scoped=true", function () {
      api.rerender('d537f992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin/views/layout/components/AppMain.vue"
export default component.exports